export default __webpack_public_path__ + "static/media/demoPic.ff84ce4b.jpeg";